/**
 * Application configuration
 * Centralized configuration for environment variables
 */

// Get API base URL from environment variables with fallback
const apiUrl = import.meta.env.VITE_API_URL;

// if (!apiUrl) {
//   //console.warn('VITE_API_URL environment variable is not set. Using fallback.');
// }

export const API_BASE = apiUrl ? `${apiUrl}/api` : '/api';

// Log the API base URL in development mode
if (import.meta.env.DEV) {
  //console.log('API_BASE configured as:', API_BASE);
}
